<template>
  <div>
    <div class="is-flex is-align-items-center">
      <link-entity
        v-if="stat.resources.applicant"
        :payload="stat.resources.applicant"
        :additional_data="{ resource_type: 'Applicant' }"
      ></link-entity>
      <div style="width: 24px;"></div>
      <link-entity
        v-if="stat.resources.position"
        :payload="stat.resources.position"
        :additional_data="{ resource_type: 'Position' }"
      ></link-entity>
      <div style="width: 24px;"></div>
      <link-entity
        v-if="stat.resources.company"
        :payload="stat.resources.company"
        :additional_data="{ resource_type: 'Company' }"
      ></link-entity>
      <div style="width: 24px;"></div>
      <a v-if="stat.resource_type == 'Offer'" @click="changeOfferMessage" class="button is-info change_offer_status">Change Offer Message</a>
    </div>
    <div v-if="payload.show_details">
      <p><b>CREATED AT: </b>{{ time_helper.makeTimeReadable(stat.created_at) }}</p>
      <p><b>Designator: </b>{{ stat.designator }}</p>
      <p><b>Title: </b>{{ stat.title }}</p>
      <div v-if="stat.content != undefined && stat.content.length > 0">
        <p><b>Content</b></p>
        <p v-html="$sanitize(stat.content)"></p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import TimeHelper from '@/custom/classes/time_helper.js'
import LinkEntity from '@/components/LinkEntity'
export default {
  name: 'stat-resources',
  props: ['payload'],
  data () {
    return {
      time_helper: new TimeHelper(),
      stat: this.payload.stat
    }
  },
  methods: {
    changeOfferMessage () {
      this.create({ designator: 'offer-status-modal', component_name: 'OfferStatusForm', offer_data: { id: this.stat.resource_id }, modal_title: 'Change Offer Message and Status' })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    LinkEntity
  }
}
</script>
<style scoped>
  .change_offer_status{
    font-size: 10px;
  }
</style>
